import React, { useEffect, useState } from "react";
import ReusableTable from "../../../components/common/table";
import { Button, Popconfirm, Space } from "antd";
import { ReactComponent as AddSvg } from "../../../assets/images/add.svg";
import FilterComponent from "../../../components/common/filter";
import { useNavigate } from "react-router";
import ConfirmModal from "../../../components/common/alert-popup";
import { ReactComponent as ViewSvg } from "../../../assets/images/action/view.svg";
import { ReactComponent as DeleteSvg } from "../../../assets/images/action/delete.svg";
import { ReactComponent as EditSvg } from "../../../assets/images/action/edit.svg";
import { ReactComponent as DisableSvg } from "../../../assets/images/action/Shield Cross.svg";
import CommonFilter from "../../../components/common/filter";
import { useDispatch, useSelector } from "react-redux";
import useSelection from "antd/es/table/hooks/useSelection";
import { deleteSubscriptionFun, listSubscriptionFun, updateSubscriptionFun } from "../../../redux/reducer/SubscriptionSlice";
import dayjs from "dayjs";
import { useDebounce } from "../../../customHooks";


const ManageSubscription = () => {
  const [filteredData, setFilteredData] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [refereshData, setRefereshData] = useState(false);
  const [disableId, setDisableId] = useState(null);
  const [disableStatus, setDisableStatus] = useState(null)
  const [currentPage, setCurrentPage] = useState(1);
  const [tableParams, setTableParams] = useState({
    page: 1,
    size: 10,
    search_value: "",
    search_key: "",
    status: undefined,
    position: undefined,
  });

  const {listSubscription, listSubscriptionCount,  listSubLoading, listSubError} = useSelector(
    (state) => state?.subscription
  );

  const debouncedSearchValue = useDebounce(tableParams.search_value, 500);

  
  useEffect(()=>{
    dispatch(listSubscriptionFun(tableParams))
},[refereshData,  tableParams.page, tableParams.size,
  debouncedSearchValue,
  tableParams.status,
  tableParams.position,
])


  const [modalConfig, setModalConfig] = useState({
    open: false,
    actionType: "",
  });
  const handleDateFilter = (dates, dateStrings) => {
    if (!dates) {
      setFilteredData(dataSource);
      return;
    }
    const [startDate, endDate] = dateStrings;
    const filtered = dataSource.filter((item) => {
      const itemDate = new Date(item.date_added);
      return itemDate >= new Date(startDate) && itemDate <= new Date(endDate);
    });
    setFilteredData(filtered);
  };


  // pagination


  const paginationConfig = {
    pageSizeOptions: ["10", "20", "50"], 
    showSizeChanger: true, 
    showQuickJumper: true, 
    total: listSubscriptionCount || 1, 
    current: tableParams.page, 
    pageSize: tableParams.size, 
    onChange: (page, pageSize) => {
      setCurrentPage(page); 
      setTableParams((prev) => ({ ...prev, page, size: pageSize }));
    },
  };
  
  const handleTableChange = (pagination) => {
    setTableParams((prev) => ({
      ...prev,
      page: pagination.current,
      size: pagination.pageSize,
    }));
  };

  // pagination end

  const showModal = (actionType) => {
    setModalConfig({ open: true, actionType });
  };

  const closeModal = () => {
    setModalConfig({ open: false, actionType: "" });
  };

  const handleSearch = (searchText) => {
    const filtered = dataSource.filter((item) =>
      item.tenant_name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const subdata = useSelector(prev => prev) 

 

 
  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: (text, record, index) => (tableParams.page - 1) * tableParams.size + index + 1, 
    },
    {
      title: "Subscription Name",
      dataIndex: "name_en",
      key: "subscription_name",
      type: "search",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      type: "search",
    },
    // {
    //   title: "No. Of Categories",
    //   dataIndex: "nos_categories",
    //   key: "nos_categories",
    //   type: "search",
    //   width: 220, 
    //   render: () => "0",
    // },
    {
      title: "Date Added",
      dataIndex: "created_at",
      key: "date_added",
      type: "date",
      // render: (date) => dayjs(date).format("MM-DD-YYYY"),
      render: (date) => {
        const dateObject = new Date(date);
        const day = String(dateObject.getUTCDate()).padStart(2, '0');       
        const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0'); 
        const year = dateObject.getUTCFullYear();                          
        return `${month}-${day}-${year}`;
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      type: "select",
      width: "90px",
      render: (status) => (status === 1 ? <p className="active-status">Active</p> : <p className="inactive-status">Inactive</p>), // Check if status is 1
      options: [
        { label: "Active", value: 1 },
        { label: "Inactive", value: 0 },
       ],
    },
  ];

  const dataSource = [
    {
      key: "1",
      sr_no: "1",
      subscription_name: "Acme Corp",
      nos_categories: 50,
      price: 80,
      status: "Active",
      date_added: "2024-02-15",
    },
    {
      key: "2",
      sr_no: "2",
      subscription_name: "Tech Solutions",
      nos_categories: 120,
      price: 80,
      status: "Inactive",
      date_added: "2023-05-10",
    },
    {
      key: "3",
      sr_no: "3",
      subscription_name: "Innovate Inc.",
      nos_categories: 80,
      price: 80,
      status: "Active",
      date_added: "2024-03-01",
    },
  ];

  const handleEdit = (record) => {
    navigate("edit-subscription", { state: { subscriptionData: record } });
  };
  const [deleteId, setDeleteId] = useState(null); // State to store subscription ID for deletion

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    showModal("delete"); // Open the modal
  };

  const handleConfirm = async () => {
    try {
      if (modalConfig.actionType === "delete" && deleteId) {
        await dispatch(deleteSubscriptionFun(deleteId));
      } else if (modalConfig.actionType === "disable" && disableId) {
        await dispatch(updateSubscriptionFun({ id: disableId, data: { status: 0 } }));     
      }else if (modalConfig.actionType === "enable"){
        await dispatch(updateSubscriptionFun({ id: disableId, data: { status: 1 } }));
      }
    } catch (error) {
      console.error("Action failed:", error);
    }finally{
      setRefereshData((prev) => !prev);
      setDisableId(null);
    }
    closeModal();
  };
  
  // const handleConfirm = async () => {
  //   if (modalConfig.actionType === "delete" && deleteId) {
  //     try {
  //       await dispatch(deleteSubscriptionFun(deleteId));
  //       console.log(`Subscription ID ${deleteId} deleted successfully!`);
  //       setRefereshData((prev) => !prev)
  //       setDeleteId(null);
  //     } catch (error) {
  //       console.error("Failed to delete subscription:", error);
  //     }
  //   }
  //   closeModal();
  // };

  const handleDisableClick = (id, status) => {
    if(status === 1){
      showModal("disable", id, status)
    }else if(status === 0){
      showModal("enable", id, status)
    } else{
      
    }    
    setDisableStatus(status)
    setDisableId(id);
    // showModal("disable"); // Open the modal for confirmation
  };
  

  const actionItems = (record) =>  [
    {
      key: "edit",
      label: (
        <>
          <EditSvg style={{ marginRight: 8, color: "red" }} />
          Edit Details
        </>
      ),
      // onClick: () => navigate("edit-subscription"),
      onClick: (record) => handleEdit(record),
    },
    {
      key: "disable",
      label: (
        <>
       
       <DisableSvg style={{ marginRight: 8, color: `${record.status === 1 ? "green" : "red" }`}} />
         {record.status === 1 ?   "Disable": "Enable"}
      

        </>
      ),
      // onClick: () => showModal("disable"),
      onClick: (record) => handleDisableClick(record.id, record?.status),
    },
    {
      key: "delete",
      label: (
        <>
          <DeleteSvg style={{ marginRight: 8, color: "red" }} />
          Delete subscription
        </>
      ),
      // onClick: () => showModal("delete"),
      // onClick: (record) => handleDelete(record.id),
      onClick: (record) => handleDeleteClick(record.id), 
    },
  ];
  const handleFilterChange = (key, value, reset = false) => {
    setTableParams((prev) => {
      if (reset) {
        return {
          ...prev,
          
          search_key: "",
          search_value: "",
          status: undefined,
          position: undefined,
        };
      }
      if (key === "status" || key === "position") {
        return {
          ...prev,
         
          [key]: value,
          search_key: "",
          search_value: "",
        };
      }
      return {
        ...prev,
        
        search_key: key,
        search_value: value,
        status: undefined,
        position: undefined,
      };
    });
  };
 
  return (
    <div>
      <div className="addBx">
        <div className="filterBx">
          {/* <Space>
            <CommonFilter
              columns={columns}
              onFilterChange={handleFilterChange}
              searchValue={tableParams.search_value}
            />
          </Space> */}
        </div>
        <Button
          type="primary"
          icon={<AddSvg />}
          onClick={() => navigate("add-subscription")}
        >
          Add Subscription
        </Button>
      </div>
      <div className="tableHeading">List of subscription</div>
      <ReusableTable
        columns={columns}
        dataSource={listSubscription}
        loading={listSubLoading}
        paginationConfig={paginationConfig}
        onChange={handleTableChange}
        actionItems={(record) => actionItems(record)}
        
      />
      <ConfirmModal
        open={modalConfig.open}
        titlePrefix="Subscription"
        messagePrefix="Subscription"
        onClose={closeModal}
        onConfirm={handleConfirm}
        actionType={modalConfig.actionType}
      />
    </div>
  );
};

export default ManageSubscription;